import { Component, OnInit, Input } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Attachment } from 'src/app/_models/attachment';
import { Block } from 'src/app/_models/block';
import { AttachmentsService } from 'src/app/_services/attachments.service';

@Component({
  selector: 'app-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss'],
})
export class BlockComponent implements OnInit {

  @Input() block: Block;

  public loading: boolean = false;

  constructor(
    private attachementService: AttachmentsService,
    public platform: Platform,
  ) {

  }

  ngOnInit() {
  }

  async openAttachment(attach: Attachment) {
    this.loading = true;
    let blob = await this.attachementService.download(attach.id);

    if (this.platform.is('ios') || this.platform.is('android')) {
      await this.attachementService.openBlob(blob);
    } else {
      let blobUrl = URL.createObjectURL(blob);
      window.open(encodeURI(blobUrl), "_system", "location=yes");
    }

    this.loading = false;
  }

}
